// @ts-ignore
import {ApiValidation} from "../../model/api/api-validation";
import {TableRecordResult} from "../../model/api/table-record-result";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {ViewConfig} from "../../model/api/view-config";
import {FieldResult} from "../../model/api/field-result";
import {WebTradeOrderView} from "../../model/internal/web-trade-order-view";
import {TradeOrderViewConfig} from "../../model/clearing/trade-order-view-config";

export class CrystalclearInternalBackUrl {
  static readonly GET_INTERNAL_TRADEORDERVIEW_VIEWS: CrystalclearBackUrl.UrlConf<ApiValidation<WebTradeOrderView[]>> = {
    url: '/api/internal/trade-order-view/user-views',
    type: ApiValidation
  };
  static readonly GET_INTERNAL_TRADEORDERVIEW_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<WebTradeOrderView>> = {
    url: '/api/internal/trade-order-view/list',
    type: TableRecordResult
  };

  static readonly SAVE_INTERNAL_TRADEORDERVIEW: CrystalclearBackUrl.UrlConf<ApiValidation<WebTradeOrderView>> = {
    url: '/api/internal/trade-order-view/save',
    type: ApiValidation
  };

  static readonly SAVE_ALL_INTERNAL_TRADEORDERVIEW: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/internal/trade-order-view/save-all',
    type: ApiValidation
  };

  static readonly DELETE_INTERNAL_TRADEORDERVIEW: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/internal/trade-order-view/delete',
    type: ApiValidation
  };

  static readonly GET_INTERNAL_DEFAULT_TEMPLATE: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/internal/trade-order-view/default-template',
    type: ApiValidation
  };

  static readonly GET_INTERNAL_TEMPLATES: CrystalclearBackUrl.UrlConf<ApiValidation<FieldResult<any>>> = {
    url: '/api/internal/trade-order-view/templates',
    type: ApiValidation
  };

  static readonly GET_INTERNAL_TEMPLATE_TRADEORDER: CrystalclearBackUrl.UrlConf<ApiValidation<TradeOrderViewConfig>> = {
    url: '/api/internal/trade-order-view/template/trade-order',
    type: ApiValidation
  };

  static readonly GET_INTERNAL_TEMPLATE_ORDER: CrystalclearBackUrl.UrlConf<ApiValidation<ViewConfig>> = {
    url: '/api/internal/trade-order-view/template/order',
    type: ApiValidation
  };

  static readonly GET_INTERNAL_TEMPLATE_ORDER_POF: CrystalclearBackUrl.UrlConf<ApiValidation<ViewConfig>> = {
    url: '/api/internal/trade-order-view/template/order-pof',
    type: ApiValidation
  };

  static readonly GET_INTERNAL_TEMPLATE_TRADE: CrystalclearBackUrl.UrlConf<ApiValidation<ViewConfig>> = {
    url: '/api/internal/trade-order-view/template/trade',
    type: ApiValidation
  };

}
